<template>
  <div class="db-wrap">
    <!-- 最顶部：角色名字操作栏（全功能按钮合并） -->
    <div class="top-search-bar">
      <label>角色名字</label>
      <input v-model="searchName" class="name-input" placeholder="输入角色名" />
      <button class="btn-search" @click="loadAllUser">加载全部角色</button>
      <button class="btn-search" @click="searchUser">查询角色</button>
      <button v-show="false" @click="reqDbApi('getbase')">获取基础属性</button>
      <button v-show="false" @click="reqDbApi('getmagic')">获取武功</button>
      <button v-show="false" @click="reqDbApi('getitem')">获取物品</button>
      <button v-show="false" @click="reqDbApi('getkey')">获取热键</button>
      <button v-show="false" @click="reqDbApi('getcutkey')">获取功能键</button>
      <button v-show="false" @click="reqDbApi('gettemp')">获取临时数据</button>
      <button class="btn-search" @click="createYaCeAccount">创建压测账号</button>
      <!--<button class="btn-search" @click="handleHeqv">合区</button>  
      <button class="btn-search" @click="handleMenwu">更新门武</button> -->
      <button class="btn-search" @click="handleDeleteUser">删除用户</button>
    </div>

    <!-- 全模块Tab切换栏 -->
    <div class="db-sub-tab">
      <button class="sub-btn" :class="{active:dbSubTab==='base'}" @click="dbSubTab='base'">基础属性getbase</button>
      <button class="sub-btn" :class="{active:dbSubTab==='magic'}" @click="dbSubTab='magic'">武功getmagic</button>
      <button class="sub-btn" :class="{active:dbSubTab==='item'}" @click="dbSubTab='item'">物品getitem</button>
      <button class="sub-btn" :class="{active:dbSubTab==='key'}" @click="dbSubTab='key'">热键getkey</button>
      <button class="sub-btn" :class="{active:dbSubTab==='cutkey'}" @click="dbSubTab='cutkey'">功能键getcutkey</button>
      <button class="sub-btn" :class="{active:dbSubTab==='temp'}" @click="dbSubTab='temp'">临时任务gettemp</button>
    </div>

    <!-- 主体内容：左侧全模块面板 + 右侧角色列表 -->
    <div class="main-content-row">
      <div class="content-left">
        <!-- 1. 基础属性面板 -->
        <div v-show="dbSubTab==='base'" class="panel-wrap">
          <div class="panel-head">
            <span>基础属性列表</span>
            <div class="btn-group">
              <button class="btn-save" @click="saveBaseToString">保存</button>
            </div>
          </div>
          <div class="db-main-wrap">
            <div class="db-left-form">
              <div class="form-three-col">
                <!-- 第一列 -->
                <div class="form-col">
                  <div class="form-item"><label>角色名字</label><input v-model="roleData.name" class="form-input" /></div>
                  <div class="form-item"><label>ID</label><input v-model="roleData.id" class="form-input" /></div>
                  <div class="form-item"><label>账号</label><input v-model="roleData.account" class="form-input" /></div>
                  <div class="form-item"><label>背包密码</label><input v-model="roleData.bagPwd" class="form-input" /></div>
                  <div class="form-item"><label>团队ID</label><input v-model.number="roleData.teamId" class="form-input" /></div>
                  <div class="form-item"><label>门派</label><input v-model="roleData.school" class="form-input" /></div>
                  <div class="form-item"><label>登陆时间</label><input v-model="roleData.loginTime" class="form-input" /></div>
                  <div class="form-item"><label>创建时间</label><input v-model="roleData.createTime" class="form-input" /></div>
                  <div class="form-item">
                    <label>性别</label>
                    <select v-model="roleData.gender" class="form-select">
                      <option value="男">男</option>
                      <option value="女">女</option>
                    </select>
                  </div>
                  <div class="form-item"><label>地图ID</label><input v-model.number="roleData.mapId" class="form-input" /></div>
                  <div class="form-item"><label>X</label><input v-model.number="roleData.x" class="form-input" /></div>
                  <div class="form-item"><label>Y</label><input v-model.number="roleData.y" class="form-input" /></div>
                  <div class="form-item"><label>元宝</label><input v-model.number="roleData.gold" class="form-input" /></div>
                  <div class="form-item"><label>声望</label><input v-model.number="roleData.rep" class="form-input" /></div>
                  <div class="form-item"><label>light</label><input v-model.number="roleData.light" class="form-input" /></div>
                  <div class="form-item"><label>dark</label><input v-model.number="roleData.dark" class="form-input" /></div>
                  <div class="form-item"><label>元气最大</label><input v-model.number="roleData.maxVital" class="form-input" /></div>
                  <div class="form-item"><label>天魂</label><input v-model.number="roleData.soul1" class="form-input" /></div>
                </div>
                <!-- 第二列 -->
                <div class="form-col">
                  <div class="form-item"><label>内功最大</label><input v-model.number="roleData.maxNei" class="form-input" /></div>
                  <div class="form-item"><label>外功最大</label><input v-model.number="roleData.maxWai" class="form-input" /></div>
                  <div class="form-item"><label>武功最大</label><input v-model.number="roleData.maxWu" class="form-input" /></div>
                  <div class="form-item"><label>活力最大</label><input v-model.number="roleData.maxHuo" class="form-input" /></div>
                  <div class="form-item"><label>Talent</label><input v-model.number="roleData.talent" class="form-input" /></div>
                  <div class="form-item"><label>GoodChar</label><input v-model.number="roleData.goodChar" class="form-input" /></div>
                  <div class="form-item"><label>BadChar</label><input v-model.number="roleData.badChar" class="form-input" /></div>
                  <div class="form-item"><label>Adaptive</label><input v-model.number="roleData.adaptive" class="form-input" /></div>
                  <div class="form-item"><label>Revival</label><input v-model.number="roleData.revival" class="form-input" /></div>
                  <div class="form-item"><label>Immunity</label><input v-model.number="roleData.immunity" class="form-input" /></div>
                  <div class="form-item"><label>浩然</label><input v-model.number="roleData.haoran" class="form-input" /></div>
                  <div class="form-item"><label>元气当前</label><input v-model.number="roleData.nowVital" class="form-input" /></div>
                  <div class="form-item"><label>内功当前</label><input v-model.number="roleData.nowNei" class="form-input" /></div>
                  <div class="form-item"><label>外功当前</label><input v-model.number="roleData.nowWai" class="form-input" /></div>
                  <div class="form-item"><label>武功当前</label><input v-model.number="roleData.nowWu" class="form-input" /></div>
                  <div class="form-item"><label>活力当前</label><input v-model.number="roleData.nowHuo" class="form-input" /></div>
                  <div class="form-item"><label>地魂</label><input v-model.number="roleData.soul2" class="form-input" /></div>
                </div>
                <!-- 第三列 -->
                <div class="form-col">
                  <div class="form-item"><label>Health</label><input v-model.number="roleData.health" class="form-input" /></div>
                  <div class="form-item"><label>Satiety</label><input v-model.number="roleData.satiety" class="form-input" /></div>
                  <div class="form-item"><label>Poisoning</label><input v-model.number="roleData.poison" class="form-input" /></div>
                  <div class="form-item"><label>头防御</label><input v-model.number="roleData.defHead" class="form-input" /></div>
                  <div class="form-item"><label>手防御</label><input v-model.number="roleData.defHand" class="form-input" /></div>
                  <div class="form-item"><label>腿防御</label><input v-model.number="roleData.defLeg" class="form-input" /></div>
                  <div class="form-item"><label>ExtraExp</label><input v-model.number="roleData.extraExp" class="form-input" /></div>
                  <div class="form-item"><label>AddablestatePoint</label><input v-model.number="roleData.addPoint" class="form-input" /></div>
                  <div class="form-item"><label>TotalStatePoint</label><input v-model.number="roleData.totalPoint" class="form-input" /></div>
                  <div class="form-item"><label>CurrentGrade</label><input v-model.number="roleData.grade" class="form-input" /></div>
                  <div class="form-item"><label>时装模式</label><input v-model.number="roleData.fashionMode" class="form-input" /></div>
                  <div class="form-item"><label>职业</label><input v-model.number="roleData.job" class="form-input" /></div>
                  <div class="form-item"><label>人魂</label><input v-model.number="roleData.soul3" class="form-input" /></div>
                </div>
                <!-- 第四列 -->
                <div class="form-col">
                  <div class="form-item"><label>天赋点</label><input v-model.number="roleData.talentPoint" class="form-input" /></div>
                  <div class="form-item"><label>天赋经验</label><input v-model.number="roleData.talentExp" class="form-input" /></div>
                  <div class="form-item"><label>天赋级别</label><input v-model.number="roleData.talentLv" class="form-input" /></div>
                  <div class="form-item"><label>根骨</label><input v-model.number="roleData.gen" class="form-input" /></div>
                  <div class="form-item"><label>身法</label><input v-model.number="roleData.shen" class="form-input" /></div>
                  <div class="form-item"><label>悟性</label><input v-model.number="roleData.wu" class="form-input" /></div>
                  <div class="form-item"><label>武学</label><input v-model.number="roleData.wuxue" class="form-input" /></div>
                  <div class="form-item"><label>绑定钱币</label><input v-model.number="roleData.bindCoin" class="form-input" /></div>
                  <div class="form-item"><label>经验倍数</label><input v-model.number="roleData.expRate" class="form-input" /></div>
                  <div class="form-item"><label>经验时间</label><input v-model.number="roleData.expTime" class="form-input" /></div>
                  <div class="form-item"><label>VIP等级</label><input v-model.number="roleData.vipLv" class="form-input" /></div>
                  <div class="form-item"><label>VIP时间</label><input v-model="roleData.vipTime" class="form-input" /></div>
                  <div class="form-item"><label>合成熟练度</label><input v-model.number="roleData.makeLv" class="form-input" /></div>
                  <div class="form-item"><label>门派贡献</label><input v-model.number="roleData.schoolCoin" class="form-input" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 2. 武功面板 -->
        <div v-show="dbSubTab==='magic'" class="panel-wrap">
          <div class="panel-head">
            <div class="select-row">
              <label>武功分组：</label>
              <select v-model="magicGroup" @change="onMagicGroupChange">
                <option value="基本">基本</option>
                <option value="不羁">不羁</option>
                <option value="武功">武功</option>
                <option value="上层">上层</option>
              </select>
            </div>
            <div class="btn-group">
              <button class="btn-save" @click="saveMagicToString">保存</button>
            </div>
          </div>
          <div class="magic-table">
            <div class="table-head">
              <span>lkey</span><span>rname</span><span>rskill</span>
            </div>
            <div class="table-row" v-for="(item,idx) in magicList" :key="idx">
              <input v-model.number="item.lkey" class="cell-input" />
              <input v-model="item.rname" class="cell-input" />
              <input v-model.number="item.rskill" class="cell-input" />
            </div>
          </div>
        </div>

        <!-- 3. 物品面板 -->
        <div v-show="dbSubTab==='item'" class="panel-wrap">
          <div class="panel-head">
            <div class="select-row">
              <label>物品分组：</label>
              <select v-model="itemGroup" @change="onItemGroupChange">
                <option value="背包">背包</option>
                <option value="仓库">仓库</option>
                <option value="穿戴">穿戴</option>
                <option value="时装">时装</option>
              </select>
            </div>
            <div class="btn-group">
              <button class="btn-save" @click="saveItemToString">保存</button>
            </div>
          </div>
         <div class="item-scroll-wrap">
  <div class="item-table">
    <div class="table-head">
      <span>lkey</span><span>rid</span><span>rname</span><span>rcount</span><span>rcolor</span><span>rDur</span><span>rDurMax</span><span>rSmithLv</span><span>rAdd</span>
      <span>rlockState</span><span>rlocktime</span><span>rdatatime</span><span>rsettingcount</span><span>rsetting1</span><span>rsetting2</span><span>rsetting3</span><span>rsetting4</span>
    </div>
    <!-- 外层容器判断数组非空，v-for单独放在行 -->
    <div v-if="itemList.length > 0">
      <div class="table-row" v-for="(item,idx) in itemList" :key="idx">
        <input v-model.number="item.lkey" class="cell-input" />
        <input v-model.number="item.rid" class="cell-input" />
        <input v-model="item.rname" class="cell-input" />
        <input v-model.number="item.rcount" class="cell-input" />
        <input v-model.number="item.rcolor" class="cell-input" />
        <input v-model.number="item.rDurability" class="cell-input" />
        <input v-model.number="item.rDurabilityMax" class="cell-input" />
        <input v-model.number="item.rSmishingLevel" class="cell-input" />
        <input v-model.number="item.rAddition" class="cell-input" />
        <input v-model.number="item.rlockState" class="cell-input" />
        <input v-model.number="item.rlocktime" class="cell-input" />
        <input v-model="item.rdatatime" class="cell-input" />
        <input v-model.number="item.rsettingcount" class="cell-input" />
        <input v-model.number="item.rsetting1" class="cell-input" />
        <input v-model.number="item.rsetting2" class="cell-input" />
        <input v-model.number="item.rsetting3" class="cell-input" />
        <input v-model.number="item.rsetting4" class="cell-input" />
      </div>
    </div>
    <!-- 无数据占位提示 -->
    <div v-else class="empty-tip">暂无物品数据</div>
  </div>
</div>
        </div>

        <!-- 4. 热键面板 -->
        <div v-show="dbSubTab==='key'" class="panel-wrap">
          <div class="panel-head">
            <span>热键配置（仅一行）</span>
            <div class="btn-group">
              <button class="btn-save" @click="saveKeyToString">保存</button>
            </div>
          </div>
          <div class="key-table">
            <div class="table-head">
              <span>lkey</span><span>key0</span><span>key1</span><span>key2</span><span>key3</span><span>key4</span><span>key5</span><span>key6</span><span>key7</span><span>key8</span><span>key9</span>
            </div>
            <div class="table-row">
              <input v-model.number="hotkeySingle.lkey" class="cell-input" />
              <input v-model.number="hotkeySingle.key0" class="cell-input" />
              <input v-model.number="hotkeySingle.key1" class="cell-input" />
              <input v-model.number="hotkeySingle.key2" class="cell-input" />
              <input v-model.number="hotkeySingle.key3" class="cell-input" />
              <input v-model.number="hotkeySingle.key4" class="cell-input" />
              <input v-model.number="hotkeySingle.key5" class="cell-input" />
              <input v-model.number="hotkeySingle.key6" class="cell-input" />
              <input v-model.number="hotkeySingle.key7" class="cell-input" />
              <input v-model.number="hotkeySingle.key8" class="cell-input" />
              <input v-model.number="hotkeySingle.key9" class="cell-input" />
            </div>
          </div>
        </div>

        <!-- 5. 功能键面板（已修复，删除多余物品字段） -->
        <div v-show="dbSubTab==='cutkey'" class="panel-wrap">
          <div class="panel-head">
            <span>功能快捷键配置（仅一行）</span>
            <div class="btn-group">
              <button class="btn-save" @click="saveCutKeyToString">保存</button>
            </div>
          </div>
          <div class="cutkey-table">
            <div class="table-head">
              <span>lkey</span><span>skey0</span><span>skey1</span><span>skey2</span><span>skey3</span><span>skey4</span><span>skey5</span><span>skey6</span><span>skey7</span><span>skey8</span><span>skey9</span>
            </div>
            <div class="table-row">
              <input v-model.number="cutkeySingle.lkey" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey0" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey1" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey2" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey3" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey4" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey5" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey6" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey7" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey8" class="cell-input" />
              <input v-model.number="cutkeySingle.shortcutkey9" class="cell-input" />
            </div>
          </div>
        </div>

        <!-- 6. 临时任务面板 -->
        <div v-show="dbSubTab==='temp'" class="panel-wrap">
          <div class="panel-head">
            <span>主线/支线/临时任务变量</span>
            <div class="btn-group">
              <button class="btn-save" @click="saveQuestToString">保存</button>
            </div>
          </div>
          <div class="quest-wrap">
            <div class="quest-col">
              <div class="form-item"><label>compeleteQuestNo</label><input v-model.number="questData.compeleteQuestNo" class="form-input"/></div>
              <div class="form-item"><label>CurrentQuestNo</label><input v-model.number="questData.CurrentQuestNo" class="form-input"/></div>
              <div class="form-item"><label>QuestStep</label><input v-model.number="questData.QuestStep" class="form-input"/></div>
              <div class="form-item"><label>SubCurrentQuestNo</label><input v-model.number="questData.SubCurrentQuestNo" class="form-input"/></div>
              <div class="form-item"><label>SubQueststep</label><input v-model.number="questData.SubQueststep" class="form-input"/></div>
            </div>
            <div class="quest-col">
              <div class="form-item"><label>QuestTemp0</label><input v-model.number="questData.QuestTemp0" class="form-input"/></div>
              <div class="form-item"><label>QuestTemp1</label><input v-model.number="questData.QuestTemp1" class="form-input"/></div>
              <div class="form-item"><label>QuestTemp2</label><input v-model.number="questData.QuestTemp2" class="form-input"/></div>
              <div class="form-item"><label>QuestTemp3</label><input v-model.number="questData.QuestTemp3" class="form-input"/></div>
              <div class="form-item"><label>QuestTemp4</label><input v-model.number="questData.QuestTemp4" class="form-input"/></div>
            </div>
            <div class="quest-col">
              <div class="form-item"><label>QusetTemp5</label><input v-model.number="questData.QusetTemp5" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp6</label><input v-model.number="questData.QusetTemp6" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp7</label><input v-model.number="questData.QusetTemp7" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp8</label><input v-model.number="questData.QusetTemp8" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp9</label><input v-model.number="questData.QusetTemp9" class="form-input"/></div>
            </div>
            <div class="quest-col">
              <div class="form-item"><label>QusetTemp10</label><input v-model.number="questData.QusetTemp10" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp11</label><input v-model.number="questData.QusetTemp11" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp12</label><input v-model.number="questData.QusetTemp12" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp13</label><input v-model.number="questData.QusetTemp13" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp14</label><input v-model.number="questData.QusetTemp14" class="form-input"/></div>
            </div>
            <div class="quest-col">
              <div class="form-item"><label>QusetTemp15</label><input v-model.number="questData.QusetTemp15" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp16</label><input v-model.number="questData.QusetTemp16" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp17</label><input v-model.number="questData.QusetTemp17" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp18</label><input v-model.number="questData.QusetTemp18" class="form-input"/></div>
              <div class="form-item"><label>QusetTemp19</label><input v-model.number="questData.QusetTemp19" class="form-input"/></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧角色列表 -->
      <div class="content-right">
        <div class="list-header">全部角色列表</div>
        <div class="list-scroll">
          <div
            class="list-row"
            :class="{ active: selectRole === item }"
            v-for="item in roleList"
            :key="item"
            @click="selectRoleItem(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>

    </div>

    <!-- 底部接口返回提示 -->
    <div class="res-text" v-if="dbRes">接口返回：{{ dbRes }}</div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { GAME_API } from '@/utils/apiBase';
const props = defineProps(['serverName'])
import { ref, reactive } from 'vue'
import { showToast } from '@/utils/toast'
const baseUrl = `${GAME_API}/api/FUWUQI`
const dbSubTab = ref('base')
// 全局通用状态
const searchName = ref('')
const roleList = ref([])
const selectRole = ref('')
const dbRes = ref('')
// 1. 基础属性数据模型
const roleData = reactive({
  name: "", id: "", account: "", bagPwd: "", teamId: 0, school: "",
  loginTime: "", createTime: "", gender: "男", mapId: 1, x: 0, y: 0,
  gold: 0, rep: 0, light: 0, dark: 0, maxVital: 0, soul1: 0, maxNei: 0,
  maxWai: 0, maxWu: 0, maxHuo: 0, talent: 0, goodChar: 0, badChar: 0,
  adaptive: 0, revival: 0, immunity: 0, haoran: 0, nowVital: 0, nowNei: 0,
  nowWai: 0, nowWu: 0, nowHuo: 0, soul2: 0, health: 0, satiety: 0, poison: 0,
  defHead: 0, defHand: 0, defLeg: 0, extraExp: 0, addPoint: 0, totalPoint: 0,
  grade: 0, fashionMode: 0, job: 0, soul3: 0, talentPoint: 0, talentExp: 0,
  talentLv: 0, gen: 0, shen: 0, wu: 0, wuxue: 0, bindCoin: 0, expRate: 0,
  expTime: 0, vipLv: 0, vipTime: "", makeLv: 0, schoolCoin: 0
})
// 2. 武功相关状态
const magicGroup = ref('基本')
const magicList = ref([])
// 缓存全部武功多分组完整字符串（一次请求全部缓存）
let magicAllGroups = ""
// 3. 物品相关状态
const itemGroup = ref('背包')
const itemList = ref([])
// 缓存全部物品多分组完整字符串
let itemAllGroups = ""
// 4. 热键单行数据
const hotkeySingle = reactive({
  lkey: 0, key0: 0, key1: 0, key2: 0, key3: 0, key4: 0, key5: 0, key6: 0, key7: 0, key8: 0, key9: 0
})
// 5. 功能键单行数据
const cutkeySingle = reactive({
  lkey: 0, shortcutkey0: 0, shortcutkey1: 0, shortcutkey2: 0, shortcutkey3: 0, shortcutkey4: 0,
  shortcutkey5: 0, shortcutkey6: 0, shortcutkey7: 0, shortcutkey8: 0, shortcutkey9: 0
})
// 6. 任务数据模型
const questData = reactive({
  compeleteQuestNo: 0, CurrentQuestNo: 0, QuestStep: 0,
  SubCurrentQuestNo: 0, SubQueststep: 0,
  QuestTemp0: 0, QuestTemp1: 0, QuestTemp2: 0, QuestTemp3: 0, QuestTemp4: 0,
  QusetTemp5: 0, QusetTemp6: 0, QusetTemp7: 0, QusetTemp8: 0, QusetTemp9: 0,
  QusetTemp10: 0, QusetTemp11: 0, QusetTemp12: 0, QusetTemp13: 0, QusetTemp14: 0,
  QusetTemp15: 0, QusetTemp16: 0, QusetTemp17: 0, QusetTemp18: 0, QusetTemp19: 0
})
// ====================== 公共工具函数 ======================
const getVal = (arr, idx) => arr[idx] ?? '';
const getNum = (arr, idx) => Number(arr[idx] || 0);

/**
 * 底层请求解析函数，不切换tab，供【查询全部】和按钮复用
 * @param {string} apiName getbase/getmagic/getitem/getkey/getcutkey/gettemp
 * @param {string} name 角色名
 */
async function fetchAndParseDbApi(apiName, name) {
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/${apiName}?servername=${props.serverName}&name=${encodeURIComponent(name)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    const ret = res.data
    if (!ret) return { api: apiName, ok: false, msg: "返回空" }
    switch(apiName){
      case 'getbase':
        parseBaseData(ret)
        break
      case 'getmagic':
        magicAllGroups = ret
        renderMagicByGroup(magicGroup.value)
        break
      case 'getitem':
        itemAllGroups = ret
        renderItemByGroup(itemGroup.value)
        break
      case 'getkey':
        parseHotkeyData(ret)
        break
      case 'getcutkey':
        parseCutkeyData(ret)
        break
      case 'gettemp':
        parseQuestData(ret)
        break
    }
    return { api: apiName, ok: true, data: ret }
  } catch(err) {
    return { api: apiName, ok: false, msg: err.message }
  }
}

// ====================== 接口1：加载全部角色 getalluser ======================
async function loadAllUser() {
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${baseUrl}/getalluser?servername=${props.serverName}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    if (res.data.code === 200 && res.data.msg) {
      const names = res.data.msg.split(/\r?\n/).filter(name => name.trim())
      roleList.value = names
      dbRes.value = `加载全部角色成功，共${names.length}个角色`
    } else {
      dbRes.value = "获取角色列表失败：" + JSON.stringify(res.data)
    }
  } catch (err) {
    dbRes.value = "加载全部角色接口异常：" + err.message
  }
}

// ====================== 接口2：查询单个角色【改造：一次性拉取全部6套数据】 ======================
async function searchUser() {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = '请输入角色名字'
    return
  }
  // 选中当前角色，清空旧缓存
  selectRole.value = name
  magicAllGroups = ""
  itemAllGroups = ""
  magicList.value = []
  itemList.value = []

  dbRes.value = "正在查询角色，加载全部模块数据中..."
  const apis = ['getbase','getmagic','getitem','getkey','getcutkey','gettemp']
  try {
    // 并行请求全部6个接口
    const promises = apis.map(api => fetchAndParseDbApi(api, name))
    const results = await Promise.allSettled(promises)
    const successCount = results.filter(r => r.status === 'fulfilled' && r.value.ok).length
    dbRes.value = `查询角色【${name}】完成，成功加载 ${successCount}/${apis.length} 个模块，可切换上方Tab查看`
    // 查询完默认切到基础属性tab
    dbSubTab.value = 'base'
  } catch (err) {
    dbRes.value = "查询角色批量加载异常：" + err.message
  }
}

// ====================== 统一读取接口分发（原有按钮继续使用，保留切tab逻辑） ======================
async function reqDbApi(apiName) {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = "请先在右侧选择角色"
    return
  }
  const res = await fetchAndParseDbApi(apiName, name)
  dbRes.value = `${apiName} 接口返回：${res?.data ?? res?.msg}`
  if(res.ok){
    dbSubTab.value = apiName
  }
}

// ====================== 基础属性解析 ======================
function parseBaseData(dataStr) {
  const arr = dataStr.split('#');
  const len = arr.length;
  roleData.name = getVal(arr,0);
  roleData.account = getVal(arr,1);
  roleData.id = getVal(arr,2);
  roleData.bagPwd = getVal(arr,3);
  roleData.teamId = getNum(arr,4);
  roleData.school = getVal(arr,5);
  roleData.loginTime = getVal(arr,6);
  roleData.createTime = getVal(arr,7);
  roleData.gender = getNum(arr,8) === 1 ? '女' : '男';
  roleData.mapId = getNum(arr,9);
  roleData.x = getNum(arr,10);
  roleData.y = getNum(arr,11);
  roleData.gold = getNum(arr,12);
  roleData.rep = getNum(arr,13);
  roleData.light = getNum(arr,14);
  roleData.dark = getNum(arr,15);
  roleData.maxVital = getNum(arr,16);
  roleData.maxNei = getNum(arr,17);
  roleData.maxWai = getNum(arr,18);
  roleData.maxWu = getNum(arr,19);
  roleData.maxHuo = getNum(arr,20);
  roleData.talent = getNum(arr,21);
  roleData.goodChar = getNum(arr,22);
  roleData.badChar = getNum(arr,23);
  roleData.adaptive = getNum(arr,24);
  roleData.revival = getNum(arr,25);
  roleData.immunity = getNum(arr,26);
  roleData.haoran = getNum(arr,27);
  roleData.nowVital = getNum(arr,28);
  roleData.nowNei = getNum(arr,29);
  roleData.nowWai = getNum(arr,30);
  roleData.nowWu = getNum(arr,31);
  roleData.nowHuo = getNum(arr,32);
  roleData.health = getNum(arr,33);
  roleData.satiety = getNum(arr,34);
  roleData.poison = getNum(arr,35);
  roleData.defHead = getNum(arr,36);
  roleData.defHand = getNum(arr,37);
  roleData.defLeg = getNum(arr,38);
  roleData.extraExp = getNum(arr,39);
  roleData.addPoint = getNum(arr,40);
  roleData.totalPoint = getNum(arr,41);
  roleData.grade = getNum(arr,42);
  roleData.fashionMode = getNum(arr,43);
  roleData.job = getNum(arr,44);
  roleData.talentPoint = getNum(arr,48);
  roleData.talentExp = getNum(arr,49);
  roleData.talentLv = getNum(arr,50);
  roleData.gen = getNum(arr,51);
  roleData.shen = getNum(arr,52);
  roleData.wu = getNum(arr,53);
  roleData.wuxue = getNum(arr,54);
  roleData.bindCoin = getNum(arr,55);
  roleData.expRate = getNum(arr,56);
  roleData.expTime = getNum(arr,57);
  roleData.vipLv = getNum(arr,58);
  roleData.vipTime = getVal(arr,59);
  roleData.makeLv = getNum(arr,60);
  roleData.schoolCoin = getNum(arr,61);
  roleData.soul1 = getNum(arr,len - 17);
  roleData.soul2 = getNum(arr,len - 16);
  roleData.soul3 = getNum(arr,len - 15);
}
// ====================== 武功渲染 ======================
function renderMagicByGroup(targetName) {
  if (!magicAllGroups) {
    dbRes.value = "请先点击【获取武功】加载全部武功数据";
    magicList.value = [];
    return;
  }
  const groups = magicAllGroups.split('!')
  let targetFieldStr = ""
  for (const g of groups) {
    const splitGroup = g.split('|')
    const groupName = splitGroup[0]?.trim() || ""
    const fieldStr = splitGroup[1] || ""
    if (groupName === targetName) {
      targetFieldStr = fieldStr
      break
    }
  }
  if (!targetFieldStr) {
    magicList.value = []
    dbRes.value = `未找到武功分组：${targetName}`
    return
  }
  const cellArr = targetFieldStr.split(',').filter(item => item !== undefined)
  const newMagicData = []
  for (let rowIdx = 0; rowIdx < cellArr.length; rowIdx++) {
    const cellText = cellArr[rowIdx]
    const cellParts = cellText.split(':')
    const rname = cellParts[0]?.trim() || ""
    const rskill = Number(cellParts[1] || 0)
    newMagicData.push(reactive({
      lkey: rowIdx,
      rname: rname,
      rskill: rskill
    }))
  }
  magicList.value = newMagicData
  dbRes.value = `切换武功分组：${targetName}，共加载 ${cellArr.length} 行数据（本地缓存）`
}
function onMagicGroupChange() {
  renderMagicByGroup(magicGroup.value)
}
// ====================== 物品渲染（带8个新增字段兜底） ======================
function renderItemByGroup(targetName) {
  if (!itemAllGroups) {
    dbRes.value = "请先点击【获取物品】加载全部物品数据";
    itemList.value = [];
    return;
  }
  const groups = itemAllGroups.split('!')
  let targetItemDataStr = ""
  for (const g of groups) {
    const splitGroup = g.split('|')
    const groupName = splitGroup[0]?.trim()
    const dataStr = splitGroup[1] || ""
    if (groupName === targetName) {
      targetItemDataStr = dataStr
      break
    }
  }
  if (!targetItemDataStr) {
    itemList.value = []
    dbRes.value = `未找到物品分组：${targetName}`
    return
  }
  // 过滤纯空行、只有逗号的脏数据
  const rowStrArr = targetItemDataStr.split(',').filter(line => line.trim() !== '');
  const newItemArr = []
  for (let rowIdx = 0; rowIdx < rowStrArr.length; rowIdx++) {
    const singleLine = rowStrArr[rowIdx].trim()
    const fields = singleLine.split(':')
    // 兜底全部字段，不存在则0/空字符串
    const item = reactive({
      lkey: rowIdx,
      rid: Number(fields[0] || 0),
      rname: fields[1]?.trim() || "",
      rcount: Number(fields[2] || 0),
      rcolor: Number(fields[3] || 0),
      rDurability: Number(fields[4] || 0),
      rDurabilityMax: Number(fields[5] || 0),
      rSmishingLevel: Number(fields[6] || 0),
      rAddition: Number(fields[7] || 0),
      rlockState: Number(fields[8] ?? 0),
      rlocktime: Number(fields[9] ?? 0),
      rdatatime: "2023/6/6",
      rsettingcount: Number(fields[11] ?? 0),
      rsetting1: Number(fields[12] ?? 0),
      rsetting2: Number(fields[13] ?? 0),
      rsetting3: Number(fields[14] ?? 0),
      rsetting4: Number(fields[15] ?? 0)
    })
    newItemArr.push(item)
  }
  // 赋值后打印调试，确认数组长度
  itemList.value = newItemArr
  console.log("物品列表数据：", itemList.value)
  dbRes.value = `切换物品分组：${targetName}，共加载 ${rowStrArr.length} 行物品（本地缓存）`
}
function updateMagicCache(groupName, newGroupDataStr) {
  if (!magicAllGroups) return
  const allGroupsArr = magicAllGroups.split('!')
  const newAllGroups = []
  for (const seg of allGroupsArr) {
    const [segName] = seg.split('|')
    if (segName.trim() === groupName.trim()) {
      newAllGroups.push(`${segName}|${newGroupDataStr}`)
    } else {
      newAllGroups.push(seg)
    }
  }
  magicAllGroups = newAllGroups.join('!')
}
function updateItemCache(groupName, newGroupDataStr) {
  if (!itemAllGroups) return
  const allGroupsArr = itemAllGroups.split('!')
  const newAllGroups = []
  for (const seg of allGroupsArr) {
    const [segName] = seg.split('|')
    if (segName.trim() === groupName.trim()) {
      newAllGroups.push(`${segName}|${newGroupDataStr}`)
    } else {
      newAllGroups.push(seg)
    }
  }
  itemAllGroups = newAllGroups.join('!')
}
function onItemGroupChange() {
  renderItemByGroup(itemGroup.value)
}
// ====================== 热键/功能键/任务解析 ======================
function parseHotkeyData(dataStr) {
  const numStr = dataStr.split('|')[1];
  const nums = numStr.split(',').map(n => Number(n));
  hotkeySingle.lkey = 1;
  hotkeySingle.key0 = nums[0];
  hotkeySingle.key1 = nums[1];
  hotkeySingle.key2 = nums[2];
  hotkeySingle.key3 = nums[3];
  hotkeySingle.key4 = nums[4];
  hotkeySingle.key5 = nums[5];
  hotkeySingle.key6 = nums[6];
  hotkeySingle.key7 = nums[7];
  hotkeySingle.key8 = nums[8];
  hotkeySingle.key9 = nums[9];
}
function parseCutkeyData(dataStr) {
  const numStr = dataStr.split('|')[1];
  const nums = numStr.split(',').map(n => Number(n));
  cutkeySingle.lkey = 1;
  cutkeySingle.shortcutkey0 = nums[0];
  cutkeySingle.shortcutkey1 = nums[1];
  cutkeySingle.shortcutkey2 = nums[2];
  cutkeySingle.shortcutkey3 = nums[3];
  cutkeySingle.shortcutkey4 = nums[4];
  cutkeySingle.shortcutkey5 = nums[5];
  cutkeySingle.shortcutkey6 = nums[6];
  cutkeySingle.shortcutkey7 = nums[7];
  cutkeySingle.shortcutkey8 = nums[8];
  cutkeySingle.shortcutkey9 = nums[9];
}
function parseQuestData(dataStr) {
  const numStr = dataStr.split('|')[1];
  const nums = numStr.split(',').map(n => Number(n));
  questData.compeleteQuestNo = nums[0];
  questData.CurrentQuestNo = nums[1];
  questData.QuestStep = nums[2];
  questData.SubCurrentQuestNo = nums[3];
  questData.SubQueststep = nums[4];
  questData.QuestTemp0 = nums[5];
  questData.QuestTemp1 = nums[6];
  questData.QuestTemp2 = nums[7];
  questData.QuestTemp3 = nums[8];
  questData.QuestTemp4 = nums[9];
  questData.QusetTemp5 = nums[10];
  questData.QusetTemp6 = nums[11];
  questData.QusetTemp7 = nums[12];
  questData.QusetTemp8 = nums[13];
  questData.QusetTemp9 = nums[14];
  questData.QusetTemp10 = nums[15];
  questData.QusetTemp11 = nums[16];
  questData.QusetTemp12 = nums[17];
  questData.QusetTemp13 = nums[18];
  questData.QusetTemp14 = nums[19];
  questData.QusetTemp15 = nums[20];
  questData.QusetTemp16 = nums[21];
  questData.QusetTemp17 = nums[22];
  questData.QusetTemp18 = nums[23];
  questData.QusetTemp19 = nums[24];
}
// ====================== 保存接口6套（完全原代码不动） ======================
async function saveBaseToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  const arr = [
    roleData.name,roleData.account,roleData.id,roleData.bagPwd,roleData.teamId,roleData.school,
    roleData.loginTime,roleData.createTime,roleData.gender === '女' ? 1 : 0,
    roleData.mapId,roleData.x,roleData.y,roleData.gold,roleData.rep,roleData.light,roleData.dark,
    roleData.maxVital,roleData.maxNei,roleData.maxWai,roleData.maxWu,roleData.maxHuo,
    roleData.talent,roleData.goodChar,roleData.badChar,roleData.adaptive,roleData.revival,
    roleData.immunity,roleData.haoran,roleData.nowVital,roleData.nowNei,roleData.nowWai,
    roleData.nowWu,roleData.nowHuo,roleData.health,roleData.satiety,roleData.poison,
    roleData.defHead,roleData.defHand,roleData.defLeg,roleData.extraExp,roleData.addPoint,
    roleData.totalPoint,roleData.grade,roleData.fashionMode,roleData.job,
    roleData.soul1,roleData.soul2,roleData.soul3,
    roleData.talentPoint,roleData.talentExp,roleData.talentLv,roleData.gen,roleData.shen,
    roleData.wu,roleData.wuxue,roleData.bindCoin,roleData.expRate,roleData.expTime,
    roleData.vipLv,roleData.vipTime,roleData.makeLv,roleData.schoolCoin
  ]
  const dataStr = arr.join('#')
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/savebase?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(dataStr)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "保存基础属性成功：" + res.data
  } catch (err) {
    dbRes.value = "保存基础属性失败：" + err.message
  }
}
// 2.保存武功 savemagic（改为提交全部4组完整缓存数据）
async function saveMagicToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  if(!magicAllGroups) { dbRes.value="请先点击【获取武功】加载全部武功数据"; return }
  const cellStrList = magicList.value.map(item => `${item.rname}:${item.rskill}`)
  const currentGroupFullStr = cellStrList.join(',')
  updateMagicCache(magicGroup.value, currentGroupFullStr)
  const submitAllData = magicAllGroups
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/savemagic?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(submitAllData)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "全部武功分组保存成功：" + res.data
    reqDbApi('getmagic')
  } catch (err) {
    dbRes.value = "保存武功失败：" + err.message
  }
}
//3.保存物品 saveitem（改为提交全部4组完整缓存数据）
async function saveItemToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  if(!itemAllGroups) { dbRes.value="请先点击【获取物品】加载全部物品数据"; return }
  const lineStrList = itemList.value.map(item => {
    return `${item.rid}:${item.rname}:${item.rcount}:${item.rcolor}:${item.rDurability}:${item.rDurabilityMax}:${item.rSmishingLevel}:${item.rAddition}:${item.rlockState}:${item.rlocktime}:${item.rdatatime}:${item.rsettingcount}:${item.rsetting1}:${item.rsetting2}:${item.rsetting3}:${item.rsetting4}`
  })
  const currentGroupFullStr = lineStrList.join(',')
  updateItemCache(itemGroup.value, currentGroupFullStr)
  const groupMap = {}
  itemAllGroups.split('!').forEach(seg => {
    const [gName, gData] = seg.split('|')
    if(gName) groupMap[gName.trim()] = gData || ''
  })
  const fixedOrderGroups = [
    `仓库|${groupMap['仓库'] || ''}`,
    `背包|${groupMap['背包'] || ''}`,
    `穿戴|${groupMap['穿戴'] || ''}`,
    `时装|${groupMap['时装'] || ''}`
  ]
  const submitAllData = fixedOrderGroups.join('!')
  try {
    const token = sessionStorage.getItem('token')
    const formData = new URLSearchParams()
    formData.append('data', submitAllData)
    const res = await axios.post(`${baseUrl}/saveitem?servername=${props.serverName}&name=${encodeURIComponent(name)}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "全部物品分组保存成功（含锁/设置字段，顺序：仓库→背包→穿戴→时装）：" + res.data
  } catch (err) {
    dbRes.value = "保存物品失败：" + err.message
  }
}
async function saveKeyToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  const arr = [hotkeySingle.key0,hotkeySingle.key1,hotkeySingle.key2,hotkeySingle.key3,hotkeySingle.key4,hotkeySingle.key5,hotkeySingle.key6,hotkeySingle.key7,hotkeySingle.key8,hotkeySingle.key9]
  const dataStr = `热键|${arr.join(',')}`
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/savekey?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(dataStr)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "保存热键成功：" + res.data
  } catch (err) {
    dbRes.value = "保存热键失败：" + err.message
  }
}
async function saveCutKeyToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  const arr = [cutkeySingle.shortcutkey0,cutkeySingle.shortcutkey1,cutkeySingle.shortcutkey2,cutkeySingle.shortcutkey3,cutkeySingle.shortcutkey4,cutkeySingle.shortcutkey5,cutkeySingle.shortcutkey6,cutkeySingle.shortcutkey7,cutkeySingle.shortcutkey8,cutkeySingle.shortcutkey9]
  const dataStr = `功能键|${arr.join(',')}`
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/savecutkey?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(dataStr)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "保存功能键成功：" + res.data
  } catch (err) {
    dbRes.value = "保存功能键失败：" + err.message
  }
}
async function saveQuestToString() {
  const name = searchName.value.trim()
  if(!name) { dbRes.value="请先选择角色"; return }
  const arr = [
    questData.compeleteQuestNo,questData.CurrentQuestNo,questData.QuestStep,
    questData.SubCurrentQuestNo,questData.SubQueststep,
    questData.QuestTemp0,questData.QuestTemp1,questData.QuestTemp2,questData.QuestTemp3,questData.QuestTemp4,
    questData.QusetTemp5,questData.QusetTemp6,questData.QusetTemp7,questData.QusetTemp8,questData.QusetTemp9,
    questData.QusetTemp10,questData.QusetTemp11,questData.QusetTemp12,questData.QusetTemp13,questData.QusetTemp14,
    questData.QusetTemp15,questData.QusetTemp16,questData.QusetTemp17,questData.QusetTemp18,questData.QusetTemp19,
  ]
  const dataStr = `任务|${arr.join(',')}`
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/savetemp?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(dataStr)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "保存任务数据成功：" + res.data
  } catch (err) {
    dbRes.value = "保存任务数据失败：" + err.message
  }
}
// 右侧列表点击选中角色（切换角色清空武功/物品缓存）
function selectRoleItem(name) {
  selectRole.value = name
  searchName.value = name
  // 切换角色，清空缓存，下次点击获取重新拉取
  magicAllGroups = ""
  itemAllGroups = ""
  magicList.value = []
  itemList.value = [] // 强制置空数组，不会残留undefined
}
// 合区 heqv?name=输入框角色名
async function handleHeqv() {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = "请先在输入框填写角色名字"
    return
  }
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/heqv?servername=${props.serverName}&name=${encodeURIComponent(name)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "合区接口返回：" + res.data
  } catch (err) {
    dbRes.value = "合区请求异常：" + err.message
  }
}
// 更新门武 menwu?data=输入框角色名
async function handleMenwu() {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = "请先在输入框填写角色名字"
    return
  }
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/menwu?servername=${props.serverName}&data=${encodeURIComponent(name)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "更新门武接口返回：" + res.data
  } catch (err) {
    dbRes.value = "更新门武请求异常：" + err.message
  }
}
// 删除用户 delete?name=输入框角色名
async function handleDeleteUser() {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = "请先在输入框填写角色名字"
    return
  }
  if (!confirm(`确定要删除角色【${name}】吗？此操作不可恢复！`)) return
  try {
    const token = sessionStorage.getItem('token')
    const url = `${baseUrl}/delete?servername=${props.serverName}&name=${encodeURIComponent(name)}`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "删除用户接口返回：" + res.data
    selectRole.value = ""
    magicAllGroups = ""
    itemAllGroups = ""
    magicList.value = []
    itemList.value = []
  } catch (err) {
    dbRes.value = "删除用户请求异常：" + err.message
  }
}
// 创建压测账号 dbyace?name=角色名
async function createYaCeAccount() {
  const name = searchName.value.trim()
  if (!name) {
    dbRes.value = "请先在输入框填写角色名字"
    return
  }
  const token = sessionStorage.getItem('token')
  if (!token) {
    dbRes.value = 'token不存在，请重新登录'
    return
  }
  const url = `${baseUrl}/dbyace?servername=${props.serverName}&name=${encodeURIComponent(name)}`
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    dbRes.value = "创建压测账号接口返回：" + res.data
  } catch(err) {
    dbRes.value = "创建压测账号请求异常：" + err.message
  }
}

</script>


<style scoped>
.db-wrap {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.top-search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.name-input {
  padding: 6px 8px;
  border: 1px solid #aaa;
  width: 160px;
}
.btn-search {
  padding: 6px 16px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.db-sub-tab {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.sub-btn {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #f8f8f8;
  border-radius: 4px;
  cursor: pointer;
}
.sub-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}
.main-content-row {
  display: flex;
  gap: 15px;
}
.content-left {
  flex: 1;
}
.content-right {
  width: 220px;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  /* 核心：固定整体高度，防止无限撑开 */
  height: 560px;
}
.list-header {
  background: #e8e8e8;
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  flex-shrink: 0;
}
.list-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.list-row {
  padding: 6px 10px;
  cursor: pointer;
}
.list-row.active {
  background: #409eff;
  color: white;
}
.panel-wrap {
  margin-bottom: 15px;
}
.panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap:10px;
}
.select-row {
  display: flex;
  align-items: center;
  gap:6px;
}
.select-row select {
  padding:4px 8px;
}
.btn-group {
  display: flex;
  gap: 8px;
}
.btn-test-fill {
  padding: 4px 12px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-save {
  padding: 4px 12px;
  background: #e6a23c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* 物品横向滚动容器 */
.item-scroll-wrap {
  overflow-x: auto;
}
.magic-table, .item-table, .key-table, .cutkey-table {
  border: 1px solid #ccc;
}
.table-head {
  display: grid;
  background: #eee;
}
.table-row {
  display: grid;
  border-top: 1px solid #ddd;
}
.cell-input {
  padding: 4px;
  border: 1px solid #ddd;
}
.magic-table .table-head, .magic-table .table-row {
  grid-template-columns: 80px 160px 140px;
}
.item-table .table-head, .item-table .table-row {
  /* 混合固定宽度+自适应，长文本rname给更大空间 */
  grid-template-columns: 70px 70px 140px 80px 80px 80px 80px 90px 90px 90px 90px 90px 100px 90px 90px 90px 90px;
}
.empty-tip {
  padding: 20px;
  text-align: center;
  color: #999;
}
.key-table .table-head, .key-table .table-row,
.cutkey-table .table-head, .cutkey-table .table-row {
  grid-template-columns: 60px repeat(10, 80px);
}
.table-head span, .cell-input {
  padding: 6px 4px;
  text-align: center;
}
.quest-wrap {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}
.quest-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.form-item label {
  width: 90px;
  text-align: right;
  font-size: 13px;
}
.form-input {
  flex: 1;
  padding: 4px 6px;
  border: 1px solid #bbb;
}
.db-main-wrap {
  width: 100%;
}
.form-three-col {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.form-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.res-text {
  margin-top: 16px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
</style>